import React from 'react';
import PropTypes from 'prop-types';
import { ButtonContainer, FooterActionsContainer } from './FooterActions.style';

const FooterActions = ({
  dismissVisible,
  onDismiss,
  triggerVisible,
  onTrigger,
  triggerText,
}) => {
  if (!dismissVisible && !triggerVisible) {
    return null;
  }

  return (
    <FooterActionsContainer>
      {dismissVisible && (
        <ButtonContainer type="text" onClick={onDismiss}>
          Dismiss
        </ButtonContainer>
      )}
      {triggerVisible && (
        <ButtonContainer type="text" onClick={onTrigger}>
          {triggerText}
        </ButtonContainer>
      )}
    </FooterActionsContainer>
  );
};

FooterActions.propTypes = {
  dismissVisible: PropTypes.bool,
  triggerVisible: PropTypes.bool,
  triggerText: PropTypes.string,
  onDismiss: PropTypes.func,
  onTrigger: PropTypes.func,
};

FooterActions.defaultProps = {
  dismissVisible: false,
  triggerVisible: false,
  triggerText: undefined,
  onDismiss: undefined,
  onTrigger: undefined,
};

export default FooterActions;
